import { atom, useAtom, useSetAtom } from "jotai";

export const mobileCartShowAtom = atom(false);
const useMobileCartShow = () => {
  const atom = useAtom(mobileCartShowAtom);
  return atom;
};

export const useSetMobileCartShow = () => useSetAtom(mobileCartShowAtom);

export default useMobileCartShow;
